/* eslint-disable react/prop-types */
import React from 'react';

import { Stack, TextField, Typography } from '@mui/material';
import { clientGrey, customTextFiled, placeholderStye } from './style';



const MuiTextField = ({
    value,
    error,
    onChange,
    placeholder,
    type,
    sx,
    label,
    name,
    disabled = false,
    fullWidth,
    size = 'medium',
    rows,
    multiline
}) => (
    <Stack>
        <Typography pb="4px" fontWeight={500} fontSize={14} color={clientGrey[500]}>
            {label}
        </Typography>
        <TextField
            fullWidth={fullWidth}
            disabled={disabled}
            name={name}
            value={value}
            error={!!error}
            helperText={error}
            sx={{
                ...customTextFiled,
                backgroundColor: clientGrey[100],
                ...sx,
            }}
            inputProps={placeholderStye}
            onChange={onChange}
            placeholder={placeholder}
            type={type}
            size={size}
            rows={rows}
            multiline={multiline}
        />
        {
            rows && (
                <Typography fontSize={14} fontWeight={500} color={clientGrey[500]} textAlign="end">
                    Minimum 200 words.
                </Typography>
            )
        }
    </Stack>
);

export default MuiTextField;
